
// @group components

export default {
  name: 'CallToActionComponent',
  props: ['data']
}
